import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { OverlayContainer}  from '@angular/cdk/overlay';

@Directive({
    selector: '[appDatepicker]',
    standalone: false
})
export class  DatepickerDirective implements OnInit {

  @Input() isStart: boolean;

  overlayPane: Element;

  constructor(private elementRef: ElementRef, private overlayContainer: OverlayContainer) {
  }

  @HostListener('click') onClick(): void {
    this.overlayPane = this.getOverlayPane();
    const className = this.isStart ? 'datepicker-position-start' : 'datepicker-position-end';
    this.overlayPane?.classList.add(className);
  }

  ngOnInit(): void {
  }

  /**
   * Finds and returns the overlay pane element
   *
   * @returns the overlay pane element
   */
  private getOverlayPane(): Element {
    return this.overlayContainer
               .getContainerElement()
               .getElementsByClassName('cdk-overlay-pane')
               .item(1);
  }
}
